$(function () {
    // Включаем встроенные в Bootstrap тултипы
    $('[data-bs-toggle="tooltip"]').tooltip();

    // Ищем на странице элемент возврата наверх страницы, и если он есть - начинаем отслеживать скроллинг страницы
    let $scrollTop = $('#scroll-top');

    if ($scrollTop.length) {
        $(document).on('scroll', () => {
            let scrollTop = $(document).scrollTop();

            if (scrollTop > 100 && $scrollTop.is(':hidden')) {
                $scrollTop.fadeIn();
            } else if (scrollTop <= 100 && $scrollTop.is(':visible')) {
                $scrollTop.fadeOut();
            }
        });

        $scrollTop.click(() => {
            $('body, html').animate(
                {
                    scrollTop: 0,
                },
                1000,
            );
        });
    }

    // Показываем/скрываем меню на мобильных устройствах
    $('.hamburger').click(() => {
        $('section.menu .main-menu').slideToggle();
    });

    // Инициализируем Select2
    $('.select2').select2({
        theme: 'bootstrap-5',
    });

    // Связываем два Select2 списка с брендами и марками
    $('.select2-brand').change(function () {
        let val = $(this).val(),
            models = window.models[val];

        let $model = $(this).closest('form').find('.select2-model');

        $model.empty();
        $model.append('<option></option>');

        for (let key in models) {
            if (models.hasOwnProperty(key)) {
                let model = models[key];
                $model.append('<option value="' + model + '">' + model + '</option>');
            }
        }
    });

    // Инициализируем маски
    $('[data-inputmask-mask]').inputmask();

    // Включаем триггер и автозаполнение данных в модальной форме заказа запчастей
    $('[data-order]').click(function () {
        let $this = $(this),
            brand = $this.data('orderBrand'),
            model = $this.data('orderModel'),
            parts = $this.data('orderParts');

        let modal = $('#request-modal');

        modal.find('[name="brand"]').val(brand).trigger('change');
        modal.find('[name="model"]').val(model).trigger('change');

        if (parts) {
            modal.find('[name="parts"]').val(parts.replace(/\\n/g, '\n'));
        }

        modal.modal('show');
    });

    // Навешиваем пикер даты-времени
    let date = new Date();
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);

    $('[data-datetimepicker]').datetimepicker({
        language: 'ru',
        minuteStep: 15,
        initialDate: date,
        format: 'dd.mm.yyyy H:i',
        weekStart: 1,
        startDate: new Date(),
        autoclose: true,
        todayHighlight: true,
    });
});
